export default class Kt {
  constructor(
    t = 0,
    i = [],
    s = [],
    h = [],
    e = null,
    l = null,
    r = { enabled: !1 },
    a = { enabled: !1, refresh_rate_limit: void 0 },
  ) {
    (this.ol = t),
      (this.cl = i),
      (this.gl = s),
      (this.fl = h),
      (this.bl = e),
      (this.al = l),
      (this.ml = r),
      (this.pi = a),
      (this.ol = t),
      (this.cl = i),
      (this.gl = s),
      (this.fl = h),
      (this.bl = e),
      (this.al = l),
      (this.ml = r),
      (this.pi = a);
  }
  ss() {
    return {
      s: "4.10.2",
      l: this.ol,
      e: this.cl,
      a: this.gl,
      p: this.fl,
      m: this.bl,
      v: this.al,
      c: this.ml,
      f: this.pi,
    };
  }
  static Yn(t) {
    let i = t.l;
    return (
      "4.10.2" !== t.s && (i = 0), new Kt(i, t.e, t.a, t.p, t.m, t.v, t.c, t.f)
    );
  }
}
